import Agendamento from '../agendamento/Agendamento';
import Arquivo from '../arquivos/Arquivo';
import Cids from '../cids/Cids';
import { TipoConsultaRetorno } from '../enums/EnumTipoConsultaRetorno';
import Modelos from '../modelos/Modelos';
import Tenant from '@/models/tenant/Tenant';
import Paciente from '../pacientes/Pacientes';

export default class Consulta {
    public id: number;

    public tipoConsultaId?: number;

    public listaModelos: Modelos[] = [];

    public altura: number | null;

    public peso: number | null;

    public imc: number;

    public hipoteseDiagnostica: string;

    public listaCids: Cids[] = [];

    public retorno: string;

    public agendamentoRetornoId?: number;

    public agendamentoRetorno: Agendamento;

    public arquivosEmAnexo: Arquivo[] = [];

    public files: File[] = [];

    public queixaPrincipal: string;

    public historiaMolestiaAtual: string;

    public doencasCronicas: string;

    public usoMedicamentosContinuos: string;

    public alergias: string;

    public historicoFamiliar: string;

    public pressaoArterialSis: number | null;

    public pressaoArterialDias: number | null;

    public temperatura: number | null;

    public exameFisicoObservacoes: string;

    public condutas: string;

    public dataRetorno?: Date;

    public tenantId: number;

    public pacienteId: number;

    public tenant: Tenant;

    public paciente: Paciente;

    constructor() {
      this.id = 0;
      this.listaModelos = [];
      this.altura = null;
      this.peso = null;
      this.imc = 0;
      this.hipoteseDiagnostica = '';
      this.listaCids = [];
      this.retorno = '';
      this.agendamentoRetornoId = 0;
      this.agendamentoRetorno = new Agendamento();
      this.arquivosEmAnexo = [];
      this.files = [];
      this.queixaPrincipal = '';
      this.historiaMolestiaAtual = '';
      this.doencasCronicas = '';
      this.usoMedicamentosContinuos = '';
      this.alergias = '';
      this.historicoFamiliar = '';
      this.pressaoArterialSis = null;
      this.pressaoArterialDias = null;
      this.temperatura = null;
      this.exameFisicoObservacoes = '';
      this.condutas = '';
      this.dataRetorno = undefined;
      this.tenantId = 0;
      this.pacienteId = 0;
      this.tenant = new Tenant();
      this.paciente = new Paciente();
      this.tipoConsultaId = 0;
    }
}
